module.exports = __webpack_public_path__ + "img/hr-dry-tree-04.7c87fa57.png";